import { useQuery } from '@tanstack/react-query';
import { getPriceBands, IGetPriceBandsResponseBody } from 'src/api/getPriceBands';
import { formatPriceBands } from 'src/helpers/formatPriceBands/formatPriceBands';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

export const usePriceBands = (priceSchemeId: string, searchParam?: string) => {
  const { showSnackbar } = useSnackbar();

  const { data, isFetching, refetch, ...rest } = useQuery({
    queryKey: [getBrandId(), QueryKeys.priceBands, priceSchemeId, searchParam],
    queryFn: () =>
      getPriceBands(priceSchemeId, searchParam)
        .then((res) => res.json())
        .then((res: IGetPriceBandsResponseBody) => formatPriceBands(res.data)),
    initialData: [],
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
  });

  return { priceBands: data, isFetching, refetchPriceBands: refetch, ...rest };
};
